import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';


const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';

let _entities = [];

const calculateResult = ({score}) => {
    if (!score) { return null; }
    if (!score.scaled) {
        const raw = Number(score.raw);
        const max = Number(score.max);
        if (!!max && !isNaN(raw)) {
            score.scaled = raw / max;
        } else {
            score.scaled = 0;
        }
    }
    return {score};
};

const sanitise = ({result, ...data}) => ({
    result: result && calculateResult(result),
    ...data,
    datetime: !!data.timestamp ? Date.parse(data.timestamp) : Date.now(),
});

let ActivityStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return { remove: () => this.removeChangeListener(callback) };
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    addFormChangeListener: function(callback) {
        this.on(FORM_CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    addActivity: (data) => {
        data = sanitise(data);
        const index = _entities.findIndex((e) => !!e && e.id === data.id);
        if (index < 0) {
            _entities.push(data);
        } else {
            _entities[index] = data;
        }
    },
    getAll: function(filter) {
        return _entities.filter(function(e) { return e !== undefined; });
    },
    getByRegistration: function(registration) {
        let filter;
        if (registration instanceof Array) {
            filter = function(e) { return e !== undefined && e.context.registration !== undefined && registration.includes(e.context.registration); }
        } else {
            filter = function(e) { return e !== undefined && e.context.registration !== undefined && registration == e.context.registration; }
        }
        return _entities.filter(filter);
    },
    getByCourse: function(courseId, userId) {
        const courseFilter = (e) => (e !== undefined && !!e.target && !!e.target.id) &&
            (e.target.id.length >= courseId.length) && (e.target.id.substr(0, courseId.length) === courseId);
        const filter = (!userId ? courseFilter : (e) => !!e &&
                (!!e.actor.account.name && e.actor.account.name.split('|').pop() === userId ) && courseFilter(e));
        return _entities.filter(filter);
    },
    getByUser: function(userId) {
        let filter = function(e) {
            return e !== undefined && e.actor.account.name !== undefined && e.actor.account.name.split('|').pop() == userId;
        };
        return _entities.filter(filter);
    },

});

ActivityStore.dispatchToken = CentricDispatcher.register((action) => {
    if (!!action && action.type === ActionTypes.LRS_USER_ACTIVITY_SUCCESS) {
        action.data.forEach(ActivityStore.addActivity);
        ActivityStore.emitChange();
    }
});

export default ActivityStore;
